import { ThemeSettingsBaseSectionHandler } from '../settings.section';
import { ThemeResponse } from '@key-telematics/fleet-api-client';
import { FormBuilderField } from 'app/shared/components/form-builder';
import { AdminEditorService } from '../../../admin.service';
import { ThemeEngine } from 'app/shared/components/theme';

export class ModalSettingsSectionHandler extends ThemeSettingsBaseSectionHandler {

    constructor(admin: AdminEditorService, ownerId: string, themeEngine: ThemeEngine) {
        super(admin, ownerId, themeEngine, 'modal');
    }

    async getFields(_entity: ThemeResponse): Promise<FormBuilderField[]> {
        return [
            
            this.sizeNumberField('font.size'),
            this.fontColorComboField('font.color', ['main', 'content']),

            this.backgroundColorField('background.color', ['content']),
            this.borderColorField('border.color', ['content', 'main']),
            this.sizeNumberField('border.width', 'px'),
            this.sizeNumberField('border.radius', 'px'),
            this.dropShadowField('shadow'),

            // header
            this.sizeNumberField('header.font.size'),
            this.fontWeightField('header.font.weight', ['header', 'main', 'content']),
            this.fontTransformField('header.font.transform'),
            this.fontColorComboField('header.font.color', ['header', 'main', 'content']),
            this.backgroundColorField('header.background.color', ['header', 'content']), 
            this.borderColorField('header.border.color', ['header', 'content', 'main']),

            // footer
            this.sizeNumberField('footer.font.size'),
            this.fontColorComboField('footer.font.color', ['footer', 'main', 'content']),
            this.backgroundColorField('footer.background.color', ['footer', 'content']), 
            this.borderColorField('footer.border.color', ['footer', 'content', 'main']),

        ];
    }

}
